const namespaced = true
import api from '../../api/voucherRequestControlApi.js';

const state = {
    generalData: [],
    mainLoading: false,
    voucherGeneralData: [],
    loadVoucherInfo: false,
    loadVoucherInfoUnique: false,
    authGeneralData: [],
    loadAuthInfo: false,
    vouchersRequestList: [],
    loadingMain: false,
    statusVoucherList: [],
    returnArticlesType: [],
    voucherBasicData: [],
    costGeneralData: [],
    costDestinyData: [],
    costDestinyLoading: false
}
const mutations = {
    SET_GENERAL_DATA(state, data) {
        state.generalData = data;
    },
    SET_MAIN_LOADING(state, data) {
        state.mainLoading = data;
    },

    SET_VOUCHER_GENERAL_DATA(state, data) {
        state.voucherGeneralData = data;
    },
    SET_LOAD_VOUCHER_INFO(state, data) {
        state.loadVoucherInfo = data;
    },
    SET_LOAD_VOUCHER_INFO_UNIQUE(state, data) {
        state.loadVoucherInfoUnique = data;
    },
    SET_AUTH_GENERAL_DATA(state, data) {
        state.authGeneralData = data;
    },
    SET_LOAD_AUTH_INFO(state, data) {
        state.loadAuthInfo = data;
    },
    SET_BASIC_DATA(state, data) {
        state.voucherBasicData = data;
    },
    SET_VALUE_VOUCHER_LIST(state, data) {
        state.vouchersRequestList = data;
    },
    SET_LOADING_MAIN(state, data) {
        state.loadingMain = data;
    },
    SET_STATUS_LIST(state, data) {
        state.statusVoucherList = data;
    },
    SET_RETURN_ARTICLES_TYPE(state, data){
        state.returnArticlesType = data;
    },
    SET_COST_GENERAL_DATA(state, data) {
        state.costGeneralData = data;
    },
    SET_COST_DESTINY_DATA(state, data) {
        state.costDestinyData = data;
    },
    SET_LOAD_DESTINY_COST(state, data){
        state.costDestinyLoading = data
    }

}
const actions = {
    
    index(context){
        context.commit('SET_MAIN_LOADING', true);
        return new Promise((resolve) => {
            api.index().then(function (res) {
                context.commit('SET_GENERAL_DATA', res.data);
                resolve(res.data);
                context.commit('SET_MAIN_LOADING', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_MAIN_LOADING', false);
            })
        })
    },
    getVoucherInfo(context, data) {
        context.commit('SET_LOAD_VOUCHER_INFO', true);
        return new Promise((resolve) => {
            api.getVoucherInfo(data).then(function (res) {
                context.commit('SET_VOUCHER_GENERAL_DATA', res.data);
                resolve(res.data);
                context.commit('SET_LOAD_VOUCHER_INFO', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOAD_VOUCHER_INFO', false);
            })
        })
    },

    getUniqueVoucherInfo(context, data) {
        context.commit('SET_LOAD_VOUCHER_INFO_UNIQUE', true);
        return new Promise((resolve) => {
            api.getUniqueVoucherInfo(data).then(function (res) {
                context.commit('SET_VOUCHER_GENERAL_DATA', res.data);
                resolve(res.data);
                context.commit('SET_LOAD_VOUCHER_INFO_UNIQUE', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOAD_VOUCHER_INFO_UNIQUE', false);
            })
        })
    },

    getBatchBasicInfo(context, data) {
        context.commit('SET_LOAD_VOUCHER_INFO_UNIQUE', true);
        return new Promise((resolve) => {
            api.getBatchBasicInfo(data).then(function (res) {
                context.commit('SET_BASIC_DATA', res.data);
                resolve(res.data);
                context.commit('SET_LOAD_VOUCHER_INFO_UNIQUE', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOAD_VOUCHER_INFO_UNIQUE', false);
            })
        })
    },

    getAuthInfo(context, data) {
        context.commit('SET_LOAD_AUTH_INFO', true);
        return new Promise((resolve) => {
            api.getAuthInfo(data).then(function (res) {
                context.commit('SET_AUTH_GENERAL_DATA', res.data);
                resolve(res.data);
                context.commit('SET_LOAD_AUTH_INFO', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOAD_AUTH_INFO', false);
            })
        })
    },
    updateApproval(context, data) {
        context.commit('SET_LOAD_AUTH_INFO', true);
        return new Promise(() => {
            api.updateApproval(data).then(function () {
                context.commit('SET_LOAD_AUTH_INFO', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOAD_AUTH_INFO', false);
            })
        })
    },

    getFilterGeneral(context, data) {
        context.commit('SET_LOADING_MAIN', true);
        return new Promise((resolve) => {
            api.getFilterGeneral(data).then(function (res) {
                context.commit('SET_VALUE_VOUCHER_LIST', res.data);
                resolve(res.data);
                context.commit('SET_LOADING_MAIN', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOADING_MAIN', false);
            })
        })
    },

    getVoucherStatusList(context){
        return new Promise((resolve) => {
            api.getVoucherStatusList().then(function (res) {
                context.commit('SET_STATUS_LIST', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })
    },

    getLinesStatus(context) {
        return new Promise((resolve) => {
            api.getLinesStatus().then(function (res) {
                context.commit('SET_RETURN_ARTICLES_TYPE', res.data);
                resolve(res.data);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
            })
        })
    },

    getCostData(context) {
        // context.commit('SET_MAIN_LOADING', true);
        return new Promise((resolve) => {
            api.getCostData().then(function (res) {
                context.commit('SET_COST_GENERAL_DATA', res.data);
                resolve(res.data);
                // context.commit('SET_MAIN_LOADING', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                // context.commit('SET_MAIN_LOADING', false);
            })
        })
    },

    getCostInfoByDestiny(context, data) {
        context.commit('SET_LOAD_DESTINY_COST', true);
        return new Promise((resolve) => {
            api.getCostInfoByDestiny(data).then(function (res) {
                context.commit('SET_COST_DESTINY_DATA', res.data);
                resolve(res.data);
                context.commit('SET_LOAD_DESTINY_COST', false);
            }).catch((e) => {
                context.dispatch('notifications/add', { 'color': 'error', 'visibility': true, 'timeout': 5000, 'text': e.messages }, { root: true });
                context.commit('SET_LOAD_DESTINY_COST', false);
            })
        })
    },
    deleteCostInfoDestiny(context){
        context.commit('SET_COST_DESTINY_DATA', []);
    }
}
const getters = {
    getvouchersRequestList(state) {
        return state.vouchersRequestList;
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
}